import { useEffect } from "react";

import useShouldKeepZendeskHidden from "@app/util/contexts/useShouldKeepZendeskHidden";

const useHiddenZendesk = () => {
  const shouldKeepZendeskHidden = useShouldKeepZendeskHidden();
  useEffect(() => {
    // nothing to do here, it should be hidden already. Let's not change its state.
    if (shouldKeepZendeskHidden) {
      return;
    }
    window.zE("webWidget", "hide");
    return () => window.zE("webWidget", "show");
  }, [shouldKeepZendeskHidden]);
};

export default useHiddenZendesk;
